import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { AuthContext } from '../context/AuthContext';
import { EnvelopeIcon, EyeIcon, EyeSlashIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import AuthLayout from '../components/AuthLayout';
import api from '../services/api';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);

  const initialValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().required('Required'),
  });

  const onSubmit = async (values, actions) => {
    try {
      const result = await login(values.email, values.password);
      
      if (result.success) {
        // Redirect to dashboard after successful login
        navigate('/dashboard');
      } else if (result.needsPayment) {
        // Redirect to checkout if payment is required
        navigate('/checkout');
      } else {
        actions.setFieldError('email', result.error || 'Login failed');
      }
    } catch (err) {
      // Handle payment requirement error
      if (err.response?.status === 402 && err.response?.data?.needsPayment) {
        navigate('/checkout');
      } else {
        actions.setFieldError('email', err.response?.data?.error || 'Login failed');
      }
    }
  };

  return (
    <AuthLayout heading="Log in to your account" sub={<Link to="/register" className="text-indigo-600 hover:underline">Need an account? Register</Link>}>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ isSubmitting }) => (
          <Form className="space-y-5">
            <div className="relative">
              <EnvelopeIcon className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
              <Field name="email" type="email" placeholder="Email" className="input pl-10" />
              <ErrorMessage name="email" component="div" className="text-red-500 text-xs mt-1" />
            </div>
            <div className="relative">
              <LockClosedIcon className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
              <Field name="password" type={showPassword ? 'text' : 'password'} placeholder="Password" className="input pl-10 pr-10" />
              {showPassword ? (
                <EyeSlashIcon onClick={() => setShowPassword(false)} className="w-5 h-5 absolute right-3 top-3 text-gray-400 cursor-pointer" />
              ) : (
                <EyeIcon onClick={() => setShowPassword(true)} className="w-5 h-5 absolute right-3 top-3 text-gray-400 cursor-pointer" />
              )}
              <ErrorMessage name="password" component="div" className="text-red-500 text-xs mt-1" />
            </div>
            <button type="submit" disabled={isSubmitting} className="btn-primary w-full shadow-lg transform hover:-translate-y-0.5 transition">Login</button>
          </Form>
        )}
      </Formik>
    </AuthLayout>
  );
};

export default Login; 